import React, { useState } from 'react';
import axios from 'axios';

const AdminNoteReviser = () => {
  const API_URL = process.env.REACT_APP_API_URL;
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const isAdmin = userInfo?.role === 'admin';

  const [description, setDescription] = useState('');
  const [prompt, setPrompt] = useState('');
  const [systemContent, setSystemContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [revised, setRevised] = useState('');


  if (!isAdmin) {
    return (
      <div className="container mt-4" dir="ltr">
        <div className="alert alert-danger">403 - هذه الصفحة مخصصة للمدراء فقط</div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setRevised('');

    if (!API_URL) {
      setError('API URL is not configured');
      return;
    }

    if (!description || !prompt || !systemContent) {
      setError('يجب تعبئة جميع الحقول');
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(
        API_URL + 'admin/notes/revise',
        { description, prompt, systemContent },
        { headers: { 'Accept': 'application/json' } }
      );
      setRevised(res?.data?.revised || '');
    } catch (err) {
      const msg = err?.response?.data?.error || err.message || 'حدث خطأ أثناء الاتصال';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4" dir="ltr">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">منقح الملاحظات بالذكاء الاصطناعي (للإدارة)</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">System Content</label>
              <textarea
                className="form-control"
                rows={3}
                value={systemContent}
                onChange={(e) => setSystemContent(e.target.value)}
                placeholder="مثال: You are a clinical summarization engine."
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Prompt</label>
              <textarea
                className="form-control"
                rows={5}
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder="أدخل التعليمات التي تريد إرسالها للنموذج"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows={8}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="أدخل وصف الملاحظة ليتم تنقيحه"
              />
            </div>

            {error && (
              <div className="alert alert-danger" role="alert">{error}</div>
            )}

            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  جاري المعالجة...
                </>
              ) : (
                <>تنقيح الوصف</>
              )}
            </button>
          </form>

          {revised && (
            <div className="mt-4">
              <h6>الناتج:</h6>
              <div className="p-3 border rounded bg-light" style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: revised }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminNoteReviser;
